<template>
  <div
    :class="currentTheme"
    id="app"
    draggable="false"
    :key="$route.query.lang"
  >
    <Navbar
      :mainConfig="getMainConfig"
      :navbarData="navbarData"
      @openHelpMenu="openHelpMenu"
      :getDisabledConfirm="getDisabledConfirm"
    />
    <NewHelpModal v-if="helpMenu" @closeHelpMenu="closeHelpMenu" />
    <PlayerKeyboard
      v-if="showPlayerKeyboard"
      :keyboardType="keyboardType"
      :scannedString="scannedString"
      @closePlayerKeyboard="closePlayerKeyboard"
      @confirmCodes="confirmCodes"
    />
    <router-view />
  </div>
</template>

<style lang="scss">
// @import "./assets/common/scss/commonStyle.scss";
.lightTheme {
  @import "./assets/lucky-balls/scss/global-lb.scss";
}
.darkTheme {
  @import "./assets/lucky-balls/scss/global-lb-dark.scss";
}
</style>

<script>
import { initLang, translate, languageReinit } from "./assets/common/lang";
import Navbar from "./components/general/Navbar";
import NewHelpModal from "./components/general/modals/NewHelpModal";
import PlayerKeyboard from "./components/general/modals/PlayerKeyboardModal";
import { mapGetters } from "vuex";
import $eventBus from "./eventBus";
import store from "./store";

/**
 * Calling Rebet from parent
 * @param {*} ticketId
 */
window.Rebet = (ticketId) => {
  store.dispatch("callRebet", ticketId);
};

export default {
  components: {
    Navbar,
    PlayerKeyboard,
    NewHelpModal,
  },
  data() {
    return {
      isInitalRender: true,
      keyboardType: null,
      showPlayerKeyboard: false,
      navbarData: {
        hasAccount: false,
        creditText: "credit",
        logoutButtonText: "cashout",
      },
      helpMenu: false,
      terminalActionMessage: "",
      disabledConfirmTimeout: null,
      currentTheme: "light-theme",
    };
  },
  methods: {
    loadSCSS_(name) {
      //z
      import(`./assets/common/scss/${name}.scss`);
    },
    translate(word) {
      return translate(word);
    },
    repeatTicketAgain() {
      if (this.toCreditData) {
        if ("GameID" in this.toCreditData) {
          switch (this.toCreditData.GameID) {
            case 1:
              this.luckyBallsFormatTicket(this.toCreditArray);
              break;

            default:
              //
              break;
          }
        }
      }
    },
    number2color(colorCode) {
      const colors = {
        1: "red",
        2: "green",
        3: "blue",
        4: "purple",
        5: "brown",
        6: "yellow",
        7: "orange",
        8: "silver",
      };
      return colors[colorCode];
    },
    decodeColors(colorString) {
      let colorArray = [];
      for (var i = 0; i < colorString.length; i++) {
        colorArray.push(this.number2color(parseInt(colorString.charAt(i))));
      }
      return colorArray;
    },
    decodeNumbers(numbersString) {
      if (numbersString !== null) {
        let numbers = numbersString.split("|");
        delete numbers[numbers.length - 1];
        delete numbers[0];
        let numbersNew = [];
        for (let x in numbers) {
          numbersNew.push(parseInt(numbers[x]));
        }
        return numbersNew;
      }

      return numbersString;
    },
    luckyBallsFormatTicket(data) {
      let ticket = {
        amount: 0,
        roundsTotal: 0,
        allColors: false,
        numbers: [],
        first5Sum: 0,
        firstBallSum: 0,
        firstBallParity: 0,
        firstColor: [],
        ballParity: 0,
        topColor: [],
        lastBallSum: 0,
        lastBallParity: 0,
        lastColor: [],
      };

      // Distinct ie. unique bets from data array.
      const distinctBets = [...new Set(data.map((item) => item.OddType))];

      // Total bets in array divided by unique
      ticket.roundsTotal = data.length / distinctBets.length;

      for (var key in data) {
        ticket.amount = data[key]["TicketAmount"];
        switch (data[key]["OddType"]) {
          case 1:
            if (
              data[key]["Numbers"] ==
              "|01|09|17|25|33|41|02|10|18|26|34|42|03|11|19|27|35|43|04|12|20|28|36|44|05|13|21|29|37|45|06|14|22|30|38|46|07|15|23|31|39|47|08|16|24|32|40|48|"
              //"|01|02|03|04|05|06|07|08|09|10|11|12|13|14|15|16|17|18|19|20|21|22|23|24|25|26|27|28|29|30|31|32|33|34|35|36|37|38|39|40|41|42|43|44|45|46|47|48|"
            ) {
              ticket.allColors = true;
            } else {
              const formatedNumbers = this.decodeNumbers(data[key]["Numbers"]);
              if (formatedNumbers.length === 12) {
                ticket.numbers = formatedNumbers.slice(0, 6);
                ticket.numbers2 = formatedNumbers.slice(6, 12);
              } else if (formatedNumbers.length === 18) {
                ticket.numbers = formatedNumbers.slice(0, 6);
                ticket.numbers2 = formatedNumbers.slice(6, 12);
                ticket.numbers3 = formatedNumbers.slice(12, 18);
              } else if (formatedNumbers.length === 24) {
                ticket.numbers = formatedNumbers.slice(0, 6);
                ticket.numbers2 = formatedNumbers.slice(6, 12);
                ticket.numbers3 = formatedNumbers.slice(12, 18);
                ticket.numbers4 = formatedNumbers.slice(18, 24);
              } else if (formatedNumbers.length === 30) {
                ticket.numbers = formatedNumbers.slice(0, 6);
                ticket.numbers2 = formatedNumbers.slice(6, 12);
                ticket.numbers3 = formatedNumbers.slice(12, 18);
                ticket.numbers4 = formatedNumbers.slice(18, 24);
                ticket.numbers5 = formatedNumbers.slice(24, 30);
              } else if (formatedNumbers.length === 36) {
                ticket.numbers = formatedNumbers.slice(0, 6);
                ticket.numbers2 = formatedNumbers.slice(6, 12);
                ticket.numbers3 = formatedNumbers.slice(12, 18);
                ticket.numbers4 = formatedNumbers.slice(18, 24);
                ticket.numbers5 = formatedNumbers.slice(24, 30);
                ticket.numbers6 = formatedNumbers.slice(30, 36);
              } else if (formatedNumbers.length === 42) {
                ticket.numbers = formatedNumbers.slice(0, 6);
                ticket.numbers2 = formatedNumbers.slice(6, 12);
                ticket.numbers3 = formatedNumbers.slice(12, 18);
                ticket.numbers4 = formatedNumbers.slice(18, 24);
                ticket.numbers5 = formatedNumbers.slice(24, 30);
                ticket.numbers6 = formatedNumbers.slice(30, 36);
                ticket.numbers7 = formatedNumbers.slice(36, 42);
              } else if (formatedNumbers.length === 48) {
                ticket.numbers = formatedNumbers.slice(0, 6);
                ticket.numbers2 = formatedNumbers.slice(6, 12);
                ticket.numbers3 = formatedNumbers.slice(12, 18);
                ticket.numbers4 = formatedNumbers.slice(18, 24);
                ticket.numbers5 = formatedNumbers.slice(24, 30);
                ticket.numbers6 = formatedNumbers.slice(30, 36);
                ticket.numbers7 = formatedNumbers.slice(36, 42);
                ticket.numbers8 = formatedNumbers.slice(42, 48);
              } else {
                ticket.numbers = formatedNumbers;
              }
            }
            break;
          case 2:
            ticket.first5Sum = data[key]["Odd"];
            break;
          case 3:
            ticket.firstBallSum = data[key]["Odd"];
            break;
          case 4:
            ticket.firstBallParity = data[key]["Odd"];
            break;
          case 5:
            ticket.firstColor = this.decodeColors(data[key]["Numbers"]);
            break;
          case 6:
            ticket.ballParity = data[key]["Odd"];
            break;
          case 7:
            ticket.topColor = this.decodeColors(data[key]["Numbers"]);
            break;
          case 8:
            ticket.lastBallSum = data[key]["Odd"];
            break;
          case 9:
            ticket.lastBallParity = data[key]["Odd"];
            break;
          case 10:
            ticket.lastColor = this.decodeColors(data[key]["Numbers"]);
            break;
        }
      }
      $eventBus.$emit("luckyBallsReplayTicket", ticket);
    },
    closePlayerKeyboard() {
      this.showPlayerKeyboard = false;
      this.scannedString = "";
      this.keyboardType = null;
    },
    openPlayerKeyboard(type) {
      this.keyboardType = type;
      this.showPlayerKeyboard = true;
    },
    openHelpMenu() {
      this.helpMenu = true;
    },
    closeHelpMenu() {
      this.helpMenu = false;
      clearInterval(this.getQRcodeInterval);
    },
  },
  computed: {
    ...mapGetters([
      "getMainConfig",
      "getGameConfig",
      "getGameResults",
      "getRepeatGameConfig",
      "getDisabledConfirm",
      "getBoughtTicketResp",
      "getRebetResponse",
    ]),
  },
  mounted() {
    console.log(
      "%cGIT TAG: v1.0.2",
      "background:black;color:lime;font-size:14px;"
    );
    console.log(
      "%cUse dark theme with URL param &theme=dark. Default is &theme=light",
      "background:black;color:lime;font-size:12px;"
    );
    this.$store.dispatch("callGameConfig");
    this.$store.dispatch("callGameResults");
    this.$nextTick(() => {
      initLang();
    });
    languageReinit(this.$route.query.lang);

    window.addEventListener("message", function (event) {
      if (event.data?.action === "REBET") {
        console.log("Detected post message from parent:", event);
        store.dispatch("callRebet", event.data?.payload);
      }
    });

    console.log("Detected URL PARAM theme:", this.$route.query.theme);

    if (this.$route.query.theme) {
      console.log("Detected URL PARAM theme:", this.$route.query.theme);
      if (this.$route.query.theme == "dark") {
        this.loadSCSS_("commonStyle-dark");
        this.currentTheme = "darkTheme";
      } else if (this.$route.query.theme == "light") {
        this.loadSCSS_("commonStyle");
        this.currentTheme = "lightTheme";
      }
    } else {
      console.log("By domain theme:", this.$route.query.theme);
      if (location.hostname == "localhost") {
        this.loadSCSS_("commonStyle");
        this.currentTheme = "lightTheme";
      } else if (location.hostname.indexOf("soccer") != -1) {
        this.loadSCSS_("commonStyle-dark");
        this.currentTheme = "darkTheme";
      } else {
        this.loadSCSS_("commonStyle");
        this.currentTheme = "lightTheme";
      }
      console.log("location.hostname:", location.hostname);
    }

    $eventBus.$on("disabledConfirmTimeout", () => {
      this.disabledConfirmTimeout = setTimeout(() => {
        clearTimeout(this.disabledConfirmTimeout);
        // if response doesn't come in 10 sec set disabled confirm button to false again.
        this.$store.dispatch("setDisabledConfirm", false);
      }, 40000);
    });
  },
  updated() {
    this.$nextTick(() => {
      initLang();
    });
  },
  beforeDestroy() {
    clearInterval(this.getQRcodeInterval);
    clearTimeout(this.disabledConfirmTimeout);
    $eventBus.$off("disabledConfirmTimeout");
  },
  watch: {
    getBoughtTicketResp() {
      this.$store.dispatch("setDisabledConfirm", false);
      clearTimeout(this.disabledConfirmTimeout);
    },
    getRebetResponse(data) {
      try {
        this.luckyBallsFormatTicket(data);
      } catch (error) {
        console.log("ERRRR: " + error);
      }
    },
    getGameConfig() {
      //
    },
    getMainConfig() {
      //
    },
  },
};
</script>
